import Cookies from 'js-cookie';

const getAuth = (): string | undefined => Cookies.get('auth');
export const getUserId = () => (getAuth() || '').split('.')[0];

export default getAuth;
